<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal"></app-profile-confirm-modal>
<form  class="checkingForm"
  [formGroup]="checkingAccountForm" 
  name="checkingAccountForm"  
  (ngSubmit)="checkingAccountForm.valid">
    <mapfre-alert></mapfre-alert>
  <div class="checking-form newPaymentFields acmic-radio-padding" *ngIf="((policyId?.length === 10 && currentPolicyData?.[0]?.jurisdiction?.state === 'MA') || isAcmic)">
    <div>
      <p class="account-type-radio-heading">Account Type</p>
      <mapfre-validation
        [input]="accountTypeInput"
        [form]="checkingAccountForm">
      </mapfre-validation>
    </div>
  </div>
    <div *ngFor="let input of inputs | slice:0:4; index as i" class="input">
      <ng-container *ngIf="input?.key !== 'bankAccountNumber' && input?.key !== 'confirmBankAccountNumber'">
        <mapfre-validation 
          [input]="input"
          (click)="onBlurAccountnumber()"
          [form]="checkingAccountForm"
          [maximumLength]="9"
          [changeAddressError]="changeAddressError">
        </mapfre-validation>
      </ng-container>
      <ng-container *ngIf="input?.key === 'bankAccountNumber'">
        <mapfre-validation 
          [input]="input" 
          (click)="onAccountNumber($event)"
          [form]="checkingAccountForm"
          [maximumLength]="9"
          [changeAddressError]="changeAddressError">
          #inputBank
        </mapfre-validation>
      </ng-container>
      <ng-container *ngIf="input?.key === 'confirmBankAccountNumber'">
        <mapfre-validation 
          [input]="input" 
          (click)="onAccountNumber($event)"
          [form]="checkingAccountForm"
          [maximumLength]="9"
          [changeAddressError]="changeAddressError">
          #inputBank
        </mapfre-validation>
      </ng-container>
    </div>

    <div class="address-container">
      <div class="d-flex capsule_toggles" *ngIf="policyId.length !== 10">
       <mapfre-button
         [ngClass]="{'active': isMailingAddSelected, 'add-toggle-btn': true}"
         additionalClasses="basic large-btn"
         [inputType]="'button'"
         (click)="selectAddressType('mailing-address')">
         {{'MAILING_ADDRESS' | translate}}
       </mapfre-button>
       <mapfre-button
         [ngClass]="{'active': isPOBoxAddSelected, 'add-toggle-btn': true}"
         additionalClasses="basic large-btn"
         [inputType]="'button'"
         (click)="selectAddressType('poBox-address')">
         {{'PO_BOX_ADDRESS' | translate}}
       </mapfre-button>
      </div>
      <div class="address-section">
        <div *ngFor="let input of inputs | slice:4; index as i" class="input"
          [ngClass]="{'first-input change-address-width': input?.key === 'changeAddress',
            'second-input MA_AppSuite': input?.key === 'changeAddressAPT',
            'MAZipCode': input?.key === 'changeAddress_zipCode' || input?.key === 'changeAddress_PO_zipCode',
            'MACityState': input?.key === 'changeAddress_city_state' || input?.key === 'changeAddress_PO_city_state',
            'MACitySelect': input?.key === 'changeAddress_multipleCities' || input?.key === 'changeAddress_PO_multipleCities',
            'MAState': input?.key === 'changeAddress_state' || input?.key === 'changeAddress_PO_state',
            'MASelectedState': isMailingAddSelected && (input?.key === 'changeAddress_state' || input?.key === 'changeAddress_PO_state'),
            'hide' : (input.key === 'changeAddress_city_state' && hideCityStateField)
            || (input.key === 'changeAddress_PO_city_state' && hidePoBoxCityStateField)
            || (input.key === 'changeAddress_zipCode' && isMailingAddSelected && hideZipcodeField),
           'hides' : ((input.key === 'changeAddress_multipleCities' || input.key === 'changeAddress_state') && (isPOBoxAddSelected || hideMultipleCityStateField))
            || (input.key === 'changeAddress_PO_multipleCities' || input.key === 'changeAddress_PO_state') && (isMailingAddSelected || hidePOMultipleCityStateField)
          }">
          <ng-container *ngIf="input.inputType !== 'select'">
              <mapfre-validation 
              [input]="input"
              (click)="onBlurAccountnumber()"
              [form]="checkingAccountForm"
              [maximumLength]="9"
              [changeAddressError]="changeAddressError"
              [ngClass]="{'hide' : ((input?.key === 'changeAddress' || input?.key === 'changeAddress_zipCode' || input?.key === 'changeAddress_city_state') && (policyId.length ===10 || isPOBoxAddSelected))
               || (input?.key ==='changeAddress_poBox' || input?.key === 'changeAddress_PO_zipCode' || input?.key === 'changeAddress_PO_city_state') && isMailingAddSelected,
              'hides': input?.key === 'changeAddressAPT' && (policyId.length ===10 || isPOBoxAddSelected)}">
            </mapfre-validation>
            <label class="custom_label check_custom " *ngIf="input?.key === 'changeAddress'" 
              [ngClass]="{'hide' : input?.key === 'changeAddress' && (policyId.length ===10 || isPOBoxAddSelected)}">
              {{'NUMBER_AND_STREET' | translate}}
            </label>
            <label class="custom_label check_custom" *ngIf="input?.key === 'changeAddressAPT'"
              [ngClass]="{'hide' : (policyId.length === 10 || isPOBoxAddSelected)}">{{'OPTIONAL' | translate}}
            </label>
          </ng-container>

          <ng-container *ngIf="input.inputType === 'select'">
            <label class="custom_city_label">{{'City' | translate}}</label>
            <select [id]="input.key" [formControlName]="input.key" class="custom-select custom-select-font mb8" (change)="onCitySelect($event)">
              <ng-container *ngIf="isMailingAddSelected">
                <option *ngFor="let opt of multipleCityOptionsForMailing; index as index;" [value]="opt">
                  {{opt}}
                </option>
              </ng-container>
              <ng-container *ngIf="isPOBoxAddSelected">
                <option *ngFor="let opt of multipleCityOptionsForPOBox; index as index;" [value]="opt">
                  {{opt}}
                </option>
              </ng-container>
            </select>
          </ng-container>
      </div>
    </div>
      
  </div>
  <div class="row upBtn text-center checkingrowbtm">
    <div class="col" >
      <ng-container *ngIf="whereInTheProcess===':policyid/edit-checking-account';else addAccount">
          <mapfre-button
            [ngClass]="{'custom_loader':loader}"
            additionalClasses="basic primary large-btn no-margin w240"
            [disabledValue]="checkingAccountForm?.valid && (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid) && checkingAccountForm?.touched && !loader"
            [inputType]="'submit'"
            (click)="checkingAccountForm?.valid && onSubmitAccountDetails('update')"
            [translateValue]="'UPDATE_ACCOUNT' | translate"
          >
        </mapfre-button>
      </ng-container>
      <ng-template #addAccount>
          <mapfre-button
            [ngClass]="{'custom_loader':loader}"
            additionalClasses="basic primary large-btn no-margin w240"
            [disabledValue]="checkingAccountForm?.valid && (isMailingAddSelected ? isZipcodeValid : isPoBoxZipcodeValid) && checkingAccountForm?.touched && !loader"
            [inputType]="'submit'"
            (click)="checkingAccountForm?.valid && onSubmitAccountDetails('add')"
            [translateValue]="'ADD_ACCOUNT' | translate"
          >
        </mapfre-button>
      </ng-template>
      </div>
    </div>
  </form>
  <div class="row margin-top mt24 text-center checkingrowbtm">
    <div class="col">
      <mapfre-button
        (click)="onCheckDirty()"
        additionalClasses="link-button small-btn red-link no-margin button-border-red"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [showIconsCustom]="true"
      >  {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>